export const BOOLEAN_OPTIONS = ['True', 'False'];

export const HARDWARE_FIELDS = [
    { key: "relaySupport", label: "Relay", options: BOOLEAN_OPTIONS },
    { key: "daliBusPsSupport", label: "DALI Bus PS", options: BOOLEAN_OPTIONS },
    { key: "alsSupport", label: "ALS", options: ['Als_Not_Supported', 'Als_Bh1750', 'Als_Bh1721', 'Als_Bh1730'] },
    { key: "tiltSupport", label: "Tilt", options: ['Tilt_Not_Supported', 'Tilt_Lis3dh12tr'] },
    { key: "tempSupport", label: "Temp", options: ['Temp_Not_Supported', 'Temp_Int_Adc'] },
    { key: "pmSupport", label: "PM", options: ['Pm_Not_Supported', 'Pm_Bl6523gx', 'Pm_Atm90e26'] },
    { key: "rfSupport", label: "RF", options: ['Rf_Not_Supported', 'Rf_Ebyte_CC1310', 'Rf_Meshreen_CC1310'] },
    { key: "cellSupport", label: "Cell", options: ['Cell_Not_Supported', 'Cell_BG95_M3', 'Cell_BG95_M6', 'Cell_EG912'] },
    { key: "extFlashSupport", label: "Ext Flash", options: ['Ext_Flash_Not_Supported', 'Ext_Flash_Gd25q64'] },
    { key: "extEepromSupport", label: "Ext EEPROM", options: ['Ext_Eeprom_Not_Supported', 'Ext_Eeprom_At24c64'] },
];

export const INITIAL_FORM_STATE = HARDWARE_FIELDS.reduce((acc, field) => {
    acc[field.key] = '';
    return acc;
}, { imei: '' });

export const getImei = (row) => row.device?.deviceIMEI || row.imei || row.deviceIMEI || 'N/A';

export const DATA_COLUMNS = [
    { key: "IMEI", label: "Device IMEI", access: getImei },
    { key: "relaySupport", label: "Relay", access: (row) => row.relaySupport ?? 'N/A' },
    { key: "daliBusPsSupport", label: "DALI", access: (row) => row.daliBusPsSupport ?? 'N/A' },
    { key: "alsSupport", label: "ALS", access: (row) => row.alsSupport ?? 'N/A' },
    { key: "tiltSupport", label: "Tilt", access: (row) => row.tiltSupport ?? 'N/A' },
    { key: "tempSupport", label: "Temp", access: (row) => row.tempSupport ?? 'N/A' },
    { key: "pmSupport", label: "PM", access: (row) => row.pmSupport ?? 'N/A' },
    { key: "rfSupport", label: "RF", access: (row) => row.rfSupport ?? 'N/A' },
    { key: "cellSupport", label: "Cell", access: (row) => row.cellSupport ?? 'N/A' },
    { key: "extFlashSupport", label: "Ext Flash", access: (row) => row.extFlashSupport ?? 'N/A' },
    { key: "extEepromSupport", label: "Ext EEPROM", access: (row) => row.extEepromSupport ?? 'N/A' },
];